<template>
  <!-- 邮箱修改密码 -->
  <!-- 验证邮箱验证码 -->
  <div class="email-modify-password">
    <el-form ref="emailForm" :model="emailForm" :rules="emailRules">
      <el-form-item prop="customerCode">
        <el-input :placeholder="$lang('请输入账号')" v-model="emailForm.customerCode" type="text" autocomplete="off">
          <i slot="prefix" class="iconfont el-input__icon iconyonghuming"></i>
          <div slot="suffix" class="emailCode-box">
            <span class="get-email-code-btn" :loading="loading" v-if="timeNumber === 60" @click="emailCode">{{ $lang('获取邮箱验证码') }}</span>
            <span v-else style="color: #e60012">{{ timeNumber + 's' }}</span>
          </div>
        </el-input>
      </el-form-item>
      <el-form-item prop="smsCode">
        <el-input autocomplete="new-password" :placeholder="$lang('请输入验证码')" :maxlength="6" v-model="emailForm.smsCode" @input="emailForm.smsCode = emailForm.smsCode.replace(/\D/g, '')">
          <i slot="prefix" class="iconfont el-input__icon iconyanzhengma1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input autocomplete="new-password" :placeholder="$lang('请输入密码')" v-model="emailForm.password" type="password">
          <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input autocomplete="new-password" :placeholder="$lang('请再次输入密码')" v-model="emailForm.confirmPassword" type="password">
          <i slot="prefix" class="iconfont el-input__icon iconmima1"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <!-- 重置密码 -->
    <el-button type="primary" :loading="submitLoading" class="login-btn" @click="sure">{{ $lang('确定') }}</el-button>
  </div>
</template>

<script type="text/javascript">
import { RULES } from '@utils/rules'
import { RESPONSE_SUCCESS } from '@constants'
import * as Api from '@api/base/public'
export default {
  name: 'EmailModifyPassword',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value !== this.emailForm.password) {
        callback(new Error(this.$lang('两次密码输入不一致!')))
      } else {
        callback()
      }
    }
    return {
      captcha: '', // 腾讯验证码
      captchaType: 0,
      loading: false,
      submitLoading: false,
      emailRules: {
        customerCode: [RULES.required],
        smsCode: [RULES.required],
        password: [RULES.required, RULES.checkPassword],
        confirmPassword: [RULES.required, RULES.checkPassword, { validator: validatePass, trigger: 'blur' }],
      },
      emailForm: {
        customerCode: '',
        password: '',
        confirmPassword: '',
        smsCode: '',
      },
      isSendCode: false,
      timeNumber: 60, // 重新发送验证码倒计时
      codeTimer: null, // 发送验证码定时器
    }
  },
  mounted() {
    this.initTencentCaptcha()
    this.$refs.emailForm.resetFields();
  },
  methods: {
    // 初始化tx验证码
    initTencentCaptcha() {
      // 生成实例对象
      const LanguageList = { ES: 'es', EN: 'en', CN: 'zh-cn' }
      this.captcha = this.$Captcha.init(this.tencentCaptchaCallback, { userLanguage: LanguageList[this.lang] })
    },
    // 验证码回调
    async tencentCaptchaCallback(res) {
      if (res.ret === 0) {
        const customParams = {
          ticket: res.ticket,
          randstr: res.randstr,
        }
        if (this.captchaType === 0) {
          this.getCodeFn(customParams)
        } else {
          this.submitPassword(customParams)
        }
      }
      // 验证不成功
      return null
    },
    // 获取邮箱验证码
    async emailCode() {
      const { customerCode } = this.emailForm
      if (!customerCode) {
        return this.$message.error(this.$lang('请输入账号'))
      }
      this.captchaType = 0
      this.captcha.show()
    },
    // 获取验证码
    async getCodeFn(customParams) {
      try {
        const { customerCode } = this.emailForm
        const params = {
          customerCode,
          ...customParams,
        }
        this.loading = true
        const { code, msg } = await Api.sendPasswordEmailVerifyCode(params)
        this.loading = false
        if (code === RESPONSE_SUCCESS) {
          clearInterval(this.codeTimer)
          this.codeTimer = setInterval(() => {
            this.timeNumber--
            if (this.timeNumber === 0) {
              this.timeNumber = 60
              clearInterval(this.codeTimer)
            }
          }, 1000)
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.loading = false
      }
    },
    async submitPassword(customParams) {
      try {
        const { customerCode, smsCode, password, confirmPassword } = this.emailForm
        const params = {
          customerCode: customerCode,
          smsCode: smsCode,
          password: this.$md5(password + 'jadada236t2').toUpperCase(),
          confirmPassword: this.$md5(confirmPassword + 'jadada236t2').toUpperCase(),
          ...customParams,
        }
        this.submitLoading = true
        const { code, msg } = await Api.updateVipUserPwdEmail(params)
        this.submitLoading = false
        if (code === RESPONSE_SUCCESS) {
          this.$message.success(this.$lang('密码修改成功'))
          this.$emit('reBack')
        } else {
          this.$message.error(msg)
        }
      } catch (error) {
        this.submitLoading = false
      }
    },
    async sure() {
      this.$refs.emailForm.validate((valid) => {
        if (valid) {
          this.captchaType = 1
          this.captcha.show()
        } else {
          return false
        }
      })
    },
  },
  beforeDestroy() {
    clearInterval(this.codeTimer)
  },
}
</script>

<style lang="scss" scoped>
.email-modify-password {
  .emailCode-box {
    .get-email-code-btn {
      color: #e60012;
      &:hover {
        cursor: pointer;
      }
      &:active {
        opacity: 0.8;
      }
    }
  }
  .login-btn {
    width: 100%;
    padding: 0;
    height: 40px;
    line-height: 40px;
    border: none;
    border-radius: 4px;
    background: linear-gradient(90deg, rgba(230, 0, 18, 1) 0%, rgba(230, 0, 18, 1) 100%);
    font-size: 16px;
  }
}
</style>
